module.exports = __webpack_public_path__ + "img/circular_layout.e1032bf9.svg";